module.exports = __webpack_public_path__ + "media/images/background_identity_big-520w-e8ff307b.jpg";